import { Button, Typography, styled } from '@mui/material';

export const ErrorLoginTypography = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(14),
  color: theme.palette.error.main,
}));

export const LabelField = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(16),
  lineHeight: theme.typography.pxToRem(24),
  color: theme.palette.black.main,
  weight: '700',
}));

export const ButtonLogin = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  borderRadius: theme.typography.pxToRem(44),
  color: 'white',
  width: '195px',
  marginTop: theme.spacing(2),
  '&:hover': {
    backgroundColor: theme.palette.primary.main,
  },
}));
